import { Injectable } from '@angular/core';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CalibrationEvaluateService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/CalibrationEvaluate?token="+Token).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetActiveList(Token:String,id:number):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/CalibrationEvaluate/GetActiveList?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  AddEditCalibrationEvaluate(model: General_Interface,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/CalibrationEvaluate/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }


  SubmitEvalute(model: Array<General_Interface>,Token:String,id:number):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_Model = []
    for (let item of model)
    {
      Local_Model.push({
        evaluate_id:item.id,
        answer:Number(item.dsc),
      })
    }

    var body = {
      id:id,
      token:Token,
      model:Local_Model
    }



      return this.http.post(environment.BaseUrl + "Daro/CalibrationEvaluate/SubmitEvalute",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }


  DeleteCalibrationEvaluate(id:number,Token:String):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/CalibrationEvaluate/Delete?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

}
